
import { checkPasswordSettingPage, setPassword } from "@/api/account.api";
import { CheckMsg, InfoMsg } from "@/constants/message.constant";
import { PasswordModel } from "@/interfaces/account.interface";
import { useUserStore } from "@/store";
import { ElMessage } from "element-plus";
type ValidateFieldCallback = (message?: string | Error) => void;
import { defineComponent, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { termsContent1, termsContent2 } from "../terms/common";
export default defineComponent({
  name: "setPasswordForm",
  emits: ["handleSetPassword"],
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const route = useRoute();
    const ruleForm = reactive({
      password: "",
      checkPassword: "",
    } as PasswordModel);
    const terms = ref(termsContent1 + termsContent2);
    const showTerms = ref(false);
    const passwordForm = ref();
    const rules = {
      password: [
        {
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (value === "") {
              callback(CheckMsg.CHK_PWD);
            }
            //パスワードを設定してください。（ 12～32文字 ／英文字、数字、記号※それぞれ1種類）※ - _. * ! # $ % & + / = ? ^ ` { | } ~
            else if (
              !/^(?=.*?\d)(?=.*?[A-z])(?=.*?[-_.*!#$%&+/=?^`{|}~])[A-z\d-_.*!#$%&+/=?^`{|}~]{12,32}$/.test(
                value
              )
            ) {
              callback(CheckMsg.CHK_CORRECT_PWD);
            } else {
              if (ruleForm.checkPassword !== "") {
                passwordForm.value?.validateField("checkPassword");
              }
              callback();
            }
          },
        },
      ],
      checkPassword: [
        {
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (value === "") {
              callback(CheckMsg.CHK_COMFIRM_PWD);
            } else if (value !== ruleForm.password) {
              callback(CheckMsg.CHK_SAME_PWD);
            } else {
              callback();
            }
          },
        },
      ],
    };
    const loading = ref(false);
    const isValid = ref(false); //画面認証
    //利用規約表示フラグを取得
    let showTermsFlg = route.query.terms ? true : false;
    showTerms.value = showTermsFlg;
    const checkIsValidPage = async () => {
      try {
        const {
          data: { result },
        } = await checkPasswordSettingPage({
          url: window.location.href,
          ...route.query,
        });
        isValid.value = Boolean(result);
      } catch (error) {
        router.push({ path: "/login" });
      }
    };
    checkIsValidPage();

    const handleNoAccept = () => {
      router.push({ path: "/login" });
    };
    const handleAccept = () => {
      showTerms.value = false;
    };
    const handleBackToTerms = () => {
      showTerms.value = true;
    };
    const handleSetPassword = () => {
      passwordForm.value?.validate(async (valid: unknown) => {
        if (valid) {
          loading.value = true;
          try {
            await setPassword({
              url: window.location.href,
              password: ruleForm.password,
            });
            ElMessage({
              type: "success",
              message: InfoMsg.SET_PASSWORD_COMPLETED,
            });
            await userStore.logout();
            router.push({ path: "/login" });

            loading.value = false;
          } catch (error) {
            loading.value = false;
          }
        } else {
          return false;
        }
      });
    };

    return {
      loading,
      ruleForm,
      passwordForm,
      rules,
      handleBackToTerms,
      handleSetPassword,
      terms,
      showTermsFlg,
      showTerms,
      handleNoAccept,
      handleAccept,
      isValid,
    };
  },
});
